/**
 * Smooth-scroll `#root .container.content` into view (e.g. messages / main column).
 */
export function scrollMainContentIntoView(options = {}) {
  const { skipIfModalDialogPresent = false } = options;
  if (skipIfModalDialogPresent && document.querySelector('.modal-dialog')) {
    return;
  }
  const region = document.querySelector('#root .container.content');
  if (region) {
    region.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

/**
 * Scroll to the topmost `.form-group` tied to React Final Form `errors` keys (fieldset `name`).
 */
export function scrollToFirstFormError(errors) {
  if (!errors || Object.keys(errors).length === 0) return;

  let target = null;
  let minTop = null;

  for (const key in errors) {
    if (!Object.prototype.hasOwnProperty.call(errors, key)) continue;
    if (key === '_error' || key === 'FORM_ERROR') continue;

    const fields = document.querySelectorAll(`[name="${CSS.escape(key)}"]`);
    if (fields.length === 0) continue;

    for (let fi = 0; fi < fields.length; fi++) {
      const fieldEl = fields[fi];
      const container = fieldEl.closest('.form-group');
      if (!container) continue;
      const elTop = container.getBoundingClientRect().top + window.scrollY;
      if (minTop === null || elTop < minTop) {
        minTop = elTop;
        target = container;
      }
    }
  }

  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
